import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  width: 36px;
  height: 36px;
  transition:
    background-color 0.15s ease,
    transform 0.12s ease;
  cursor: pointer;
  border-radius: 6px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }

  &:active {
    background-color: #558eff;
  }

  svg {
    width: 20px;
    height: 20px;
    display: block;
  }
`;
